import { api, API_URL } from './client';

export async function fetchSchedulerTasks(options = {}) {
    return api.get(`${API_URL}/api/v1/analytics/scheduler/tasks`, options);
}

export async function triggerSchedulerTask(dataSourceId, options = {}) {
    return api.post(`${API_URL}/api/v1/analytics/scheduler/tasks/${dataSourceId}/trigger`, {}, options);
}

export async function updateSchedulerTask(dataSourceId, body, options = {}) {
    return api.put(`${API_URL}/api/v1/analytics/scheduler/tasks/${dataSourceId}`, body, options);
}

export async function fetchSchedulerTaskRuns(dataSourceId, limit = 20, options = {}) {
    return api.get(`${API_URL}/api/v1/analytics/scheduler/tasks/${dataSourceId}/runs?limit=${limit}`, options);
}
